import React from "react";

export const QuestionnairesList = ({ questionnairesResumenList, handleNextSection }) => {

    return (
        <div className='w-100'>
            <div className='mb-3 pt-md-4'>
                <h1 className='mb-2 libre-caslon-text-regular h4 h3-md'>Questionnaire</h1>
            </div>
            <ul className='list-unstyled grid-3 questionnaires-list'>
                {questionnairesResumenList.map((questionnaire) => {
                    return <li key={questionnaire.id} className={`border rounded col p-0 ${questionnaire.completion === 100 && questionnaire.submitted && 'bg-ice-60 border-ice-60'}`}>
                        <div onClick={(event) => handleNextSection('questionnaire', event, questionnaire.id)}
                            className='cursor-pointer p-md-3 p-2 d-block text-reset text-decoration-none'>
                            <div className='d-flex align-items-center'>
                                <div className='questionnaires-icon mr-2'>
                                    <img src={questionnaire.icon} alt={questionnaire.name} width="60" height="auto" className='img-fluid' />
                                </div>
                                <div>
                                    <h2 className='h3-md h6 mb-0'>{questionnaire.name}</h2>
                                    <p className='mb-0 small h6-sm text-muted'><span className='mr-2'>{questionnaire.total_items} Questions</span>
                                        {questionnaire.completion === 100 && questionnaire.submitted && <span className='text-green'>Completed</span>}
                                        {questionnaire.completion === 0 && <span className='text-red'>Let’s Start</span>}
                                        {
                                            (
                                                (questionnaire.completion > 0 && questionnaire.completion < 100)
                                                ||
                                                (questionnaire.completion === 100 && !questionnaire.submitted)
                                            ) && <span className='text-orange'>Continue</span>
                                        }
                                    </p>
                                </div>
                                <div className='ml-auto'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill='currentColor'>
                                        <g>
                                            <path d="M9,20.2c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l7-7l-7-7C8.2,4.7,8.2,4.3,8.5,4s0.8-0.3,1.1,0l7.5,7.5
                                                              c0.3,0.3,0.3,0.8,0,1.1L9.5,20C9.4,20.2,9.2,20.2,9,20.2z"/>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </li>
                })
                }
            </ul>
        </div>
    );
}